import defaults from '../../translations/en.json';

export const detailRowDefs = {
  detailCellRendererParams: {
    detailGridOptions: {
      suppressLoadingOverlay: true,
    },
  },
};

export const commonColumnDefs = {
  wrapText: true,
  sortable: true,
  filterable: true,
  autoHeight: true,
  // flex: 1,
  resizable: true,
};

export const getColumnDefs = () => {
  const ReportName = {
    headerName: defaults.name,
    width: 150,
    filter: true,
    field: 'name',
  };
  const ReportType = {
    headerName: defaults.type,
    width: 150,
    filter: true,
    field: 'type',
  };
  const ReportGroup = {
    headerName: 'Report Group',
    width: 150,
    filter: true,
    field: 'reportGroup',
  };

  return [
    [ReportName, ReportType, ReportGroup],
    [ReportName, ReportType, ReportGroup],
  ];
};
